import { render } from "./KetQuaCLS.vue?vue&type=template&id=307a273b&scoped=true&ts=true"
import script from "./KetQuaCLS.vue?vue&type=script&lang=ts"
export * from "./KetQuaCLS.vue?vue&type=script&lang=ts"

import "./KetQuaCLS.vue?vue&type=style&index=0&id=307a273b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307a273b"]])

export default __exports__